// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kdCTO","col":"styles_col__3L7IW"};